import { useSetState } from "react-use";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { useSearchParams } from "react-router-dom";

import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// primeReact
import { Chip } from "primereact/chip";
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import { SplitButton } from "primereact/splitbutton";
import { confirmDialog } from "primereact/confirmdialog";
// components
import Modal from "../../../../components/modal/Modal";
import Contracts from "./Contracts/Contracts";
import Proposals from "./Proposals/Proposals";
import FileInput from "../../../../components/input/FileInput";
import Simulations from "./Simulations/Simulations";
//services
import { postBulkAction } from "../../../../services/Contracts/postBulkAction";
import { postSchedulesExcel } from "../../../../services/GlobalRoles/postSchedulesExcel";
import { getSchedules } from "../../../../services/GlobalRoles/getSchedules";
//utils
import { getUserId } from "../../../../utils/auth";
import { logGroup, translatedButtons } from "../../../../utils/joyHelpers";
import styles from "./Negotiations.module.css";
import usePermission from "../../../../hooks/usePermission";
import { useAppContext } from "../../../../context/AppContext";
import { getUsers } from "../../../../services/GeneralRegistration/getUsers";
import { getAllLands } from "../../../../services/Register/getAllLands";
import { getSales } from "../../../../services/Contracts/getSales";
import NotificationSchedule from "../../../../components/header/NotificationSchedule";
import { useFiltersContext } from "../../../../context/FiltersContext";

export default function Negotiations() {
  usePermission("18"); //Visualizar Negociações

  const { permissions } = useAppContext();
  const { id } = useParams(); //get id
  const { state } = useLocation();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const [selected, setSelected] = useState(1);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [selectedFile, setSelectedFile] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [visibleFileInput, setVisibleFileInput] = useState(false);
  const [modalTitle, setModalTitle] = useState(false);
  const [newAction, setNewAction] = useState();
  const [isVisible, setIsVisible] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState([]);
  const [requireDownload, setRequireDownload] = useState(false);

  const [{ run, stepIndex, steps }, setState] = useSetState({
    run: false,
    stepIndex: 0,
    steps: [],
  });
  const userId = getUserId();

  const { data: schedules, refetch: refetchSchedule } = useQuery({
    queryKey: ["schedules"],
    queryFn: () => getSchedules(),
    enabled: permissions?.includes("2"),
  });
  

  

  useEffect(() => {
    const hasSeenTour = Cookies.get(`hasSeenNegotiationsTour_${userId}`);
    if (!hasSeenTour && !visible) {
      setState({
        run: true,
        steps: [
          {
            content: (
              <>
                <h2>Escolha o que deseja acessar</h2>
                <p className="mb-0">
                  Clique aqui para alterar entre Simulação, Propostas e
                  Contratos.
                </p>
              </>
            ),
            target: ".btnSwitch",
            disableBeacon: true,
          },
          {
            content: (
              <>
                <h2>Importar Contratos</h2>
                <p className="mb-0">
                  Aqui você pode baixar a planilha de exemplo e subir seus
                  contratos Ativos por meio da planilha de excel.
                </p>
              </>
            ),
            target: ".contracts-btn",
            disableBeacon: true,
          },
          {
            content: (
              <>
                <h2>Importar Parcelas</h2>
                <p className="mb-0">
                  Aqui você pode baixar a planilha de exemplo e subir suas
                  Parcelas por meio da planilha de excel.
                </p>
              </>
            ),
            target: ".parcels-btn",
            disableBeacon: true,
          },

          {
            content: (
              <>
                <h2>Ações do Contrato</h2>
                <h4 className="mb-4">Aqui você pode:</h4>
                <ul>
                  <li>Marcar Contratos como Assinado</li>
                  <li>Desmarcar Assinatura</li>
                  <li>Marcar Contratos como Escaneado</li>
                  <li>Desmarcar Escaneado</li>
                </ul>
              </>
            ),
            target: ".actions-btn",
            disableBeacon: true,
          },
          {
            content: (
              <>
                <h2>Novo Contrato</h2>
                <p className="mb-0">
                  Lance um novo contrato a partir de uma nova simulação, aqui
                  você irá ser direcionado para o simulador.
                </p>
              </>
            ),
            target: ".new-contract",
            disableBeacon: true,
          },
        ],
      });
    }
  }, [visible]);

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;
    //    console.log(data);
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      Cookies.set(`hasSeenNegotiationsTour_${userId}`, "true");
      setState({ run: false, stepIndex: 0 });
    } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);

      setState({
        stepIndex: nextStepIndex,
      });
    }

    logGroup(type === EVENTS.TOUR_STATUS ? `${type}:${status}` : type, data);
  };

  const classSelected = "bg-success text-white";

  const items = [
    {
      template: () => (
        <Link
          to={`/enterprise/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Gestão de Vendas
        </Link>
      ),
    },
    {
      template: () => (
        <Chip
          label={
            `${selectedType === 1
              ? "Simulações"
              : selectedType === 2
              ? "Propostas"
              : "Vendas"} `
          }
          onClick={() => setIsModalVisible(true)}
          className={`${styles.switchTypeBtn} btnSwitch`}
          style={{ cursor: "pointer", border: "0.5px solid black" }}
        />
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const optionsContracts = [
    {
      label: "Subir Planinha Contratos Ativos",
      icon: "fa fa-upload",
      color: "success",
      disabled: schedules?.some((schedule) => schedule.type === "excel_sale"),
      command: () => handleOption("Planlha de Contratos", "sale"), 
    },
    {
      label: "Baixar Planilha Contratos",
      icon: "fa fa-download",
      command: () =>
        requestFile(
          "https://walletlote-arquivos.s3.amazonaws.com/ibsystem/modelo_venda.xlsx"
        ),
    },
  ];

  const optionsParcel = [
    {
      label: "Subir Planilha Parcelas",
      icon: "fa fa-upload",
      color: "success",
      disabled: schedules?.some(
        (schedule) => schedule.type === "excel_installments"
      ),
      command: () => handleOption("Planilha de Parcelas", "installment"),
    },
    {
      label: "Baixar Planilha Parcelas",
      icon: "fa fa-download",
      color: "primary",
      command: () =>
        requestFile(
          "https://walletlote-arquivos.s3.amazonaws.com/ibsystem/modelo_parcela.xlsx"
        ),
    },
  ];

  async function requestFile(link) {
    var a = document.createElement("a");
    a.href = link;
    a.click();
  }

  const handleOption = async (title, action) => {
    setNewAction(action);
    setModalTitle(title);
    setVisibleFileInput(true);
  };

  function findClientIdByName(clientName, clientData) {
    const client = clientData.find((c) => c.name === clientName);
    return client ? client.id : null;
  }

  const normalizeDate = (value) => {
    if (!value) return "";

    // Se for um número (serial Excel), converte
    if (!isNaN(value) && Number(value) > 30000 && Number(value) < 60000) {
      const excelEpoch = new Date(1899, 11, 30);
      const date = new Date(excelEpoch.getTime() + Number(value) * 86400000);

      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");

      return validateDate(`${yyyy}-${mm}-${dd}`);
    }

    // Se for no formato DD/MM/YYYY
    if (typeof value === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
      const [dd, mm, yyyy] = value.split("/");
      return validateDate(`${yyyy}-${mm}-${dd}`);
    }

    // Tenta converter diretamente como Date
    const date = new Date(value);
    if (!isNaN(date)) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");

      return validateDate(`${yyyy}-${mm}-${dd}`);
    }

    return "";
  };

  // Valida se está no formato certo e se a data realmente existe
  const validateDate = (str) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(str)) return "";

    const [yyyy, mm, dd] = str.split("-").map(Number);
    const date = new Date(yyyy, mm - 1, dd);

    // Confirma que os valores conferem com a data criada
    if (
      date.getFullYear() === yyyy &&
      date.getMonth() === mm - 1 &&
      date.getDate() === dd
    ) {
      return str;
    }

    return "";
  };

  const transformJsonSale = (jsonData) => {
    return jsonData.slice(7).map((row) => {
      return {
        team_name: row["TABELA PARA CADASTRO DE CONTRATOS"] || "",
        real_estate_name: row["__EMPTY"] || "",
        broker_name: row["__EMPTY_1"] || "",
        block_name: row["__EMPTY_2"] || "",
        land_name: row["__EMPTY_3"] || "",
        client_name: row["__EMPTY_4"] || "",
        new_date_contract: normalizeDate(row["__EMPTY_5"]) || "",
        status: row["__EMPTY_6"] || "",
        index_readjust_name: row["__EMPTY_7"] || "",
        term_discount_value: row["__EMPTY_8"] || "",
        entry_value: row["__EMPTY_9"] || "",
        number_entry_installments: row["__EMPTY_10"] || "",
        entry_rate: row["__EMPTY_11"] || "",
        intermediate_value: row["__EMPTY_12"] || "",
        number_intermediate_installments: row["__EMPTY_13"] || "",
        intermediate_rate: row["__EMPTY_14"] || "",
        intermediate_percentage: row["__EMPTY_15"] || "",
        financing_value: row["__EMPTY_16"] || "",
        number_financing_installments: row["__EMPTY_17"] || "",
        financing_rate: row["__EMPTY_18"] || "",
        debtor_correction_rate: row["__EMPTY_19"] || "",

        first_financing_installment: normalizeDate(row["__EMPTY_20"]) || "",
        last_financing_installment: normalizeDate(row["__EMPTY_21"]) || "",
        first_value_financing_installment: row["__EMPTY_22"] || "",
        last_value_financing_installment: row["__EMPTY_23"] || "",

        amortization_system: row["__EMPTY_24"] || "",
        construction_value: row["__EMPTY_25"] || "",
        number_construction_installments: row["__EMPTY_26"] || "",
        construction_rate: row["__EMPTY_27"] || "",
        construction_percentage: row["__EMPTY_28"] || "",
        single_value: row["__EMPTY_29"] || "",
        single_percentage: row["__EMPTY_30"] || "",
        signal_value: row["__EMPTY_31"] || "",
        signal_percentage: row["__EMPTY_32"] || "",
        cash_value: row["__EMPTY_33"] || "",
        number_cash_installments: row["__EMPTY_34"] || "",
        cash_percentage: row["__EMPTY_35"] || "",
        rowNum: row["__rowNum__"] + 1,
      };
    });
  };

  const transformJsonInstallment = (jsonData) => {
    return jsonData.slice(4).map((row) => {
      // console.log("Antes: " + row['__EMPTY_4'], "Depois: " + normalizeDate(row['__EMPTY_4']), "Linha: " + row['__rowNum__'] + 1);
      return {
        client_name: row["TABELA PARA CADASTRO DE PARCELAS"] || "",
        block_name: row["__EMPTY"] || "",
        land_name: row["__EMPTY_1"] || "",
        sequence_number: row["__EMPTY_2"] || "",
        value: row["__EMPTY_3"] || "",
        due_date: normalizeDate(row["__EMPTY_4"]) || "",
        payment_date: normalizeDate(row["__EMPTY_5"]) || "",
        payment_value: row["__EMPTY_6"] || "",
        discount: row["__EMPTY_7"] || "",
        addition: row["__EMPTY_8"] || "",
        description: row["__EMPTY_9"] || "",
        ib3_id: row["__EMPTY_10"] || "",
        rowNum: row["__rowNum__"] + 1,
      };
    });
  };

  const handleFileChange = async () => {
    setVisibleFileInput(false);

    const base64ToArrayBuffer = (base64) => {
      const binaryString = window.atob(base64.split(",")[1]);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    };

    const arrayBuffer = base64ToArrayBuffer(selectedFile);
    const notification = toast.loading(
      "Enviando seus dados, por favor aguarde..."
    );

    try {
      const workbook = XLSX.read(arrayBuffer, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      let params = {
        name: null,
        id: null,
        doc: null,
        enterprise_id: id,
      };

      let objData = [];
      let groupedErrors = {};

      if (newAction === "sale") {
        const allClients = await getUsers(params);
        const allLands = await getAllLands(id);
        const transformedDataSale = transformJsonSale(jsonData);

        transformedDataSale.forEach((sale) => {
          const clientId = findClientIdByName(sale.client_name, allClients);
          const landInfo = allLands.find(
            (item) =>
              String(item.block).trim() === String(sale.block_name).trim() &&
              String(item.land).trim() === String(sale.land_name)
          );

          const enrichedSale = {
            ...sale,
            client_id: clientId,
            land_id: landInfo ? landInfo.id : null,
            block_id: landInfo ? landInfo.id_block : null,
            enterprise_id: id,
          };

          const errorMessages = [];
          if (!clientId) errorMessages.push("Cliente não encontrado");
          if (!landInfo) {
            errorMessages.push("Lote não encontrado");
            errorMessages.push("Quadra não encontrada");
          }

          if (errorMessages.length > 0) {
            const key = errorMessages.join(", ");
            if (!groupedErrors[key]) {
              groupedErrors[key] = {
                obs_error: key,
                row_summary: [],
                status: 4,
                type: "excel_sale",
                code: `error-${key.replace(/\s+/g, "-").toLowerCase()}`,
              };
            }
            groupedErrors[key].row_summary.push(sale.rowNum);
          } else {
            objData.push(enrichedSale);
          }
        });
      } else {
        const allSales = await getSales(params, "contract");
        const transformedDataInstallment = transformJsonInstallment(jsonData);
        // Verifica se há dados válidos para envio
        if (transformedDataInstallment?.length > 9999) {
          toast.update(notification, {
            render: "Ops, você não pode enviar mais de 9999 linhas por vez.",
            autoClose: 5000,
            type: "error",
            isLoading: false,
          });
          return;
        }
        transformedDataInstallment.forEach((sale) => {
          const landInfo = allSales.find(
            (item) =>
              String(item.block).trim() === String(sale.block_name).trim() &&
              String(item.land).trim() === String(sale.land_name).trim() &&
              String(item.name_cli).trim() === String(sale.client_name).trim()
          );

          const enrichedSale = {
            ...sale,
            client_id: landInfo ? landInfo.client_id : null,
            land_id: landInfo ? landInfo.land_id : null,
            block_id: landInfo ? landInfo.block_id : null,
            sale_id: landInfo ? landInfo.id : null,
            enterprise_id: id,
          };

          const errorMessages = [];
          if (!landInfo) {
            errorMessages.push(
              "Informações do cliente, lote ou quadra não conferem"
            );
          }

          if (errorMessages.length > 0) {
            const key = errorMessages.join(", ");
            if (!groupedErrors[key]) {
              groupedErrors[key] = {
                obs_error: key,
                row_summary: [],
                status: 4,
                type: "excel_installments",
                code: `error-${key.replace(/\s+/g, "-").toLowerCase()}`,
              };
            }
            groupedErrors[key].row_summary.push(sale.rowNum);
          } else {
            objData.push(enrichedSale);
          }
        });
      }

      const newType = newAction === "sale" ? "sale" : "installments";
      const obj = {
        datas: objData,
        type_excel: newType,
        enterprise_id: id,
      };

      if (objData.length > 0) {
        const res = await postSchedulesExcel(obj);
        console.log(objData);
        if (res.success && !res.exceptions) {
          toast.update(notification, {
            render:
              "Planilha de Importação inserida com sucesso, acompanhe o status nas notificações",
            autoClose: 5000,
            type: "info",
            isLoading: false,
          });
        } else {
          toast.update(notification, {
            render: res.errors
              ? res.errors.file[0]
              : "Ops, algo deu errado. / Planilhas em andamento",
            autoClose: 5000,
            type: "error",
            isLoading: false,
          });
        }
      } else {
        toast.update(notification, {
          render: "Nenhum dado válido encontrado para envio.",
          autoClose: 5000,
          type: "warning",
          isLoading: false,
        });
      }

      // Se houver erros agrupados, transforma em array para exibir
      const errorData = Object.values(groupedErrors).map((err) => ({
        ...err,
        row_summary: err.row_summary.join("|"),
      }));

      if (errorData.length > 0) {
        setRequireDownload(true);
        setSelectedSchedule(errorData);
        setIsVisible(true);
      }
    } catch (error) {
      toast.update(notification, {
        render: "Ops, algo deu errado.",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
    } finally {
      refetchSchedule();
    }
  };

  const actions = [
    // {
    //   label: "Alterar Corretor",
    //   icon: "fa fa-user-pen",
    //   command: (e) => handleSelect("change_broker"),
    // },
    {
      label: "Marcar como Assinado",
      icon: "fa fa-file-signature",
      command: (e) => handleSelect("mark_signed"),
    },
    {
      label: "Desmarcar Assinatura",
      icon: "fa fa-file",
      command: (e) => handleSelect("unmark_signed"),
    },
    {
      label: "Marcar como Escaneado",
      icon: "fa fa-print",
      command: (e) => handleSelect("mark_scanned"),
    },
    {
      label: "Desmarcar Escaneado",
      icon: "fa fa-boxes-packing",
      command: (e) => handleSelect("unmark_scanned"),
    },
    // {
    //   label: "Enviar para Ação Judicial",
    //   icon: "fa fa-download",
    //   command: (e) => handleSelect("send_legal"),
    // },
  ];

  const handleConfirmButton = async (action, status) => {
    const selectedParcelIds = selectedCustomers.map(
      (selectedParcel) => selectedParcel.id
    );
    let obj, type, notification, notificationMessage, errorMessage;
    if (action === "mark_signed" || action === "unmark_signed") {
      if (status) {
        notificationMessage =
          "Os contratos foram marcados como assinados com sucesso.";
      } else {
        notificationMessage = "Os contratos foram desmarcados como assinados.";
      }
      type = "signature";
    } else if (action === "mark_scanned" || action === "unmark_scanned") {
      if (status) {
        notificationMessage =
          "Os contratos foram marcados como escaneados com sucesso.";
      } else {
        notificationMessage = "Os contratos foram desmarcados como escaneados.";
      }
      type = "scanned";
    }

    obj = {
      sales_ids: selectedParcelIds,
      type: type,
      action: status,
    };

    try {
      notification = toast.loading(
        "Por favor aguarde a ação está sendo realizada..."
      );

      const response = await postBulkAction(obj);
      errorMessage =
        response.error && response.error
          ? response.error
          : "Não foi possível fazer a ação.";
      toast.update(notification, {
        render: notificationMessage,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      if (errorMessage == undefined) {
        errorMessage = "";
      }
      toast.update(notification, {
        render: "Não foi possível realizar a ação! " + errorMessage,
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    }
  };

  const onSelectModal = (select) => {
    switch (select) {
      case 1:
        setSelected(1);
        break;
      case 2:
        setSelected(2);
        break;
      case 3:
        setSelected(3);
        break;
      default:
    }
    setVisible(false);
  };

  const handleSelect = (option) => {
    let confirmationMessage, status;
    switch (option) {
      case "mark_signed":
        status = true;
        if (selectedCustomers.length > 0) {
          confirmationMessage = "Deseja marcar os contratos como assinado?";
        } else {
          toast.warning("Selecione ao menos um contrato.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
        }
        break;
      case "unmark_signed":
        status = false;
        if (selectedCustomers.length > 0) {
          confirmationMessage =
            "Deseja desmarcar as assinaturas dos contratos?";
        } else {
          toast.warning("Selecione ao menos um contrato.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
        }
        break;
      case "mark_scanned":
        status = true;
        if (selectedCustomers.length > 0) {
          confirmationMessage = "Deseja marcar os contratos como escaneado?";
        } else {
          toast.warning("Selecione ao menos um contrato.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
        }
        break;
      case "unmark_scanned":
        status = false;
        if (selectedCustomers.length > 0) {
          confirmationMessage =
            "Deseja desmarcar os escaneamentos dos contratos?";
        } else {
          toast.warning("Selecione ao menos um contrato.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            isLoading: false,
          });
        }
        break;
      case "send_legal":
        break;

      default:
        break;
    }

    if (confirmationMessage) {
      confirmDialog({
        message: confirmationMessage,
        header: "Confirmação",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: function (event) {
          handleConfirmButton(option, status);
        },
        onHide: (e) => {
          setSelectedCustomers([]);
          setSelectAll(false);
        },
      });
    }
  };

  const {
    isModalVisible,
    setIsModalVisible,
    setSavedFilter,
    setIsProposal,
    setIsNegotiation,
    setIsSales,
    selectedType,
    setSelectedType,
    handleTypeSelection
  } = useFiltersContext();
const [searchParams, setSearchParams] = useSearchParams();
useEffect(() => {
  const typeFromURL = searchParams.get("type");

  if (typeFromURL) {
    handleTypeSelection(parseInt(typeFromURL, 10));
  } else if (!selectedType) {
    setIsModalVisible(true);
  }
}, []);

useEffect(() => {
  if (selectedType) {
    setSearchParams({ type: selectedType.toString() });
  }
}, [selectedType]);

  // useEffect(() => {
  //   console.log("setSelectedType", selectedType);
  // }, [selectedType]);




  return (
    <>
      {isVisible && (
        <NotificationSchedule
          requireDownload={requireDownload}
          setRequireDownload={setRequireDownload}
          isVisible={isVisible}
          selectedSchedule={selectedSchedule}
          setIsVisible={setIsVisible}
          onClose={() => setIsVisible(false)}
        />
      )}

      <Joyride
        callback={handleJoyrideCallback}
        continuous
        run={run}
        scrollToFirstStep
        showProgress
        showSkipButton
        stepIndex={stepIndex}
        locale={translatedButtons}
        steps={steps}
        styles={{
          options: {
            primaryColor: "#00b9a7",
            buttonNext: {
              color: "#FFFFFF",
            },
            buttonPrev: {
              color: "#FFFFFF",
            },
          },
        }}
      />
      <div className="row d-flex justify-content-between mb-3">
        <div className="col-xl-4">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        {selectedType === 3 && (
          <div className="col-xl-8">
            <div className="row justify-content-end pb-3">
              {permissions &&
                permissions.includes("28") && ( //Subir Contratos por Planilha
                  <div className="col-xl-3 col-md-6">
                    <SplitButton
                      rounded
                      label="Contratos"
                      icon="fa-solid fa-file-signature"
                      severity="info"
                      model={optionsContracts}
                      className="w-100 pb-2 contracts-btn"
                    />
                  </div>
                )}
              {permissions &&
                permissions.includes("29") && ( //Subir Parcelas por Planilha
                  <div className="col-xl-3 col-md-6">
                    <SplitButton
                      label="Parcelas"
                      icon="fa fa-file"
                      model={optionsParcel}
                      rounded
                      className="w-100 pb-2 parcels-btn"
                    />
                  </div>
                )}
              {permissions &&
                permissions.includes("30") && ( //Ações em Massa no Contrato
                  <div className="col-xl-3 col-md-6">
                    <SplitButton
                      label="Ações"
                      icon="fa-solid fa-sliders"
                      model={actions}
                      severity="secondary"
                      rounded
                      className="w-100 pb-2 actions-btn"
                    />
                  </div>
                )}
              {permissions &&
                permissions.includes("87") && ( //Realizar Simulação
                  <div className="col-xl-3 col-md-6">
                    <Button
                      rounded
                      severity="success"
                      label="Contrato"
                      onClick={() =>
                        navigate(`/enterprise/simulator/`, {
                          state: {
                            empId: id,
                            name: state ? state.name : "Empreendimento",
                            fromCard: true,
                          },
                        })
                      }
                      icon="fa fa-plus"
                      className="p-inputtext-sm me-2 m-auto w-100 new-contract"
                    />
                  </div>
                )}
            </div>
          </div>
        )}
      </div>
      
      {selectedType === 1 && <Simulations id={id} />}
      {selectedType === 2 && <Proposals id={id} />}
      {selectedType === 3 && (
        <Contracts
          id={id}
          selectAll={selectAll}
          setSelectAll={setSelectAll}
          selectedCustomers={selectedCustomers}
          setSelectedCustomers={setSelectedCustomers}
          name={state ? state.name : "Empreendimento"}
        />
      )}
      <Modal
        visible={isModalVisible}
        dynamicTitle={"Selecione o que Deseja analisar"}
        onHide={() => setIsModalVisible(false)}
        closable={!!selectedType}
      >
        <div className="row p-2 modal-switch">
          {permissions && permissions.includes("25") && (
            <div className="col-md-4 my-2">
              <div
                onClick={() => {
                  handleTypeSelection(1);
                  setSavedFilter({ tipo: "simulacao" });
                  setIsModalVisible(false);
                  setIsNegotiation(false);
                  setIsProposal(false);
                  setIsSales(false);
                }}
                className={`card card-animation d-flex align-items-center p-5 ${
                  selectedType === 1 && classSelected
                }`}
                style={{ borderRadius: "15px" }}
              >
                <h1 style={{ fontSize: "50px" }}>
                  <i className="fa-solid fa-business-time"></i>
                </h1>
                <h2>Simulações</h2>
              </div>
            </div>
          )}
          {permissions && permissions.includes("26") && (
            <div className="col-md-4 my-2">
              <div
                onClick={() => {
                  handleTypeSelection(2);
                  setSavedFilter({ tipo: "proposta" });
                  setIsModalVisible(false);
                  setIsNegotiation(false);
                  setIsProposal(true);
                  setIsSales(false);
                }}
                className={`card card-animation d-flex align-items-center p-5 ${
                  selectedType === 2 && classSelected
                }`}
                style={{ borderRadius: "15px" }}
              >
                <h1 style={{ fontSize: "50px" }}>
                  <i className="fa-solid fa-gavel"></i>
                </h1>
                <h2>Propostas</h2>
              </div>
            </div>
          )}
          {permissions && permissions.includes("27") && (
            <div className="col-md-4 my-2">
              <div
                onClick={() => {
                  handleTypeSelection(3);
                  setSavedFilter({ tipo: "venda" });
                  setIsModalVisible(false);
                  setIsNegotiation(false);
                  setIsProposal(false);
                  setIsSales(true);
                }}
                className={`card card-animation d-flex align-items-center p-5 ${
                  selectedType === 3 && classSelected
                }`}
                style={{ borderRadius: "15px" }}
              >
                <h1 style={{ fontSize: "50px" }}>
                  <i className="fa-solid fa-dollar-sign"></i>
                </h1>
                <h2>Vendas</h2>
              </div>
            </div>
          )}
        </div>
      </Modal>

      <Modal
        visible={visibleFileInput}
        dynamicTitle={modalTitle}
        onHide={(e) => setVisibleFileInput(false)}
      >
        <FileInput
          isMultiple={false}
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          onConfirmButton={handleFileChange}
          buttonConfirm={true}
          base64={true}
          type="file"
          typeFile=".xlsx,.xls"
          name="excelUpload"
          id="excelUpload"
          title="Inserir Planilha"
          icon="fa-rotate-left"
        />
      </Modal>
    </>
  );
}
